import { CellContext } from "@tanstack/react-table";
import { twMerge } from "tailwind-merge";
import Button from "../../button";

export function ActionCell<RowData>(
  props: Readonly<CellContext<RowData, any>>
) {
  const {
    row: { original, index },
    table: {
      options: {
        meta: {
          actions,
          onActionClicked,
          enableRowAction,
          enableRowActions,
          classNames,
        } = {},
      },
    },
  } = props;

  const actionsEnabled = enableRowActions?.(original, index) ?? true;
  if (!actionsEnabled || !actions?.length) return null;

  return (
    <div className={twMerge("flex flex-row gap-2", classNames?.actionCell)}>
      {actions.map((action) => (
        <Button
          size="sm"
          variant="secondary"
          key={action.type}
          disabled={enableRowAction?.(original, action.type, index) === false}
          onClick={(e) => {
            e.stopPropagation();
            onActionClicked?.(original, action.type, index);
          }}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
}
